import SecaoParceiros from './SecaoParceiros';

export { SecaoParceiros };

export default SecaoParceiros;
